console.log('✅ listing-page-component.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, setAppStateValueByKey } from '../../js/state.js';

import { fetchAllBlogCategories } from '../../services/data-services/blog-data-service.js';

export async function buildComponentBlogCategoriesSide() {
  try {
    // so it ends up in its own "translation-service" chunk:
    const { loadMyTranslationsService } = await import(
      /* webpackChunkName: "my-translator-service" */
      /* webpackPrefetch: true */
      '../../services/my-translator-service.js'
    );

    // 1) Load translations in parallel (cached after first call)
    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
      appState.SiteLanguageCookie
    );

    const {
      keyBlogCategories: lblBlogCategories,
      keyAllBlogCategories: lblAllBlogCategories,
    } = _tempTextTranslator;

    const { keyBlog: linkBlog, keyBlogCategories: linkBlogCategories } = _tempLinksTranslator;

    const dtAPIResultFeaturedArticles = await fetchAllBlogCategories();
    // filter where IsOnHomePageSideNav is true and order by DisplayOrderHomePageSideNav

    const filteredCategories = dtAPIResultFeaturedArticles
      .filter(item => item.isOnHomePageSideNav)
      .sort((a, b) => a.displayOrderHomePageSideNav - b.displayOrderHomePageSideNav);

    const blogCatLinksHtmlRows = filteredCategories

      // then map to your <a> tags
      .map(b => {
        const link = `${linkBlog}/${b.articleCategoryID}/${b.seoPageName}`;
        const style = `height: 80px;background-image: url('${b.image1FileName}');`;
        return `

                 <a href="${link}">

                    <div class="my-category-div-with-bg-image" role="button" style="${style}")>

                <span class="myBlog-catName">
                   ${b.name} 
                </span>
            </div>
        </a>


        `;
      })
      .join('');

    const finalStyle = `height: 80px;background-image: url('${APP_CONFIG.IMAGES_BASE_URL}imgs/pg/blg/allcat.jpg');`;

    const html = `

        <div class="my-blog-category-side-nav-Wrapper">

    <h3 class="my-blog-category-side-nav-Wrapper">${lblBlogCategories}</h3>
                        
        ${blogCatLinksHtmlRows}


         <a href="${linkBlogCategories}">
        <div class="my-category-div-with-bg-image" role="button" style="${finalStyle}" >
         
            <span class="myBlog-catName">
               ${lblAllBlogCategories}
            </span>
        </div>
    </a>

         </div>


        `;

    return html;

    return html;
  } catch (err) {
    console.error('❌ Error building buildComponentBlogCategoriesSide:', err);
    return '<div>Error loading buildComponentBlogCategoriesSide</div>';
  }
}
